import { jwtDecode } from 'jwt-decode';

export const decodeToken = (token) => {
  try {
    const decoded = jwtDecode(token);

    if (decoded) {
      const {
        email,
        given_name,
        preferred_username,
        name,
        ['custom:Verify']: Verify,
        phone_number,
      } = decoded;
      return {
        email,
        role: given_name,
        uid: preferred_username,
        name,
        Verify,
        phone_number,
      };
    }

    return null;
  } catch (error) {
    console.error('Failed to decode token:', error);
    return null;
  }
};
